import React from 'react';
import { MailIcon, InstagramIcon, ThumbsUpIcon, MessageCircleIcon, Share2Icon, GlobeIcon } from 'lucide-react';
import { FAQAccordion } from './FAQAccordion';
import { trackAddToCart } from '../utils/trackAddToCart';
const CART_URL = 'https://mujeresempoderadas.lat/cart/add?id=52459756126507&quantity=1';
/* ── Facebook-style post card ── */
interface FbComment {
  initial: string;
  name: string;
  text: string;
  color: string;
}
interface FbPost {
  initial: string;
  name: string;
  role: string;
  timeAgo: string;
  avatarColor: string;
  bodyParts: React.ReactNode;
  reactions: string;
  reactionCount: number;
  commentCount: number;
  shareCount: number;
  comments: FbComment[];
}
function FacebookPostCard({
  post
}: {
  post: FbPost;
}) {
  return <div className="w-full rounded-xl overflow-hidden" style={{
    background: '#FFFFFF',
    border: '1px solid #E4E6EB',
    boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
    fontFamily: 'var(--font-body)'
  }} data-id="element-286">
      {/* Post header */}
      <div className="flex items-center gap-3 px-4 pt-4 pb-3" data-id="element-287">
        <div className="w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold text-white flex-shrink-0" style={{
        background: post.avatarColor
      }} aria-label={`Avatar ${post.name}`} data-id="element-288">
          {post.initial}
        </div>
        <div className="flex-1 min-w-0" data-id="element-289">
          <p className="font-bold text-sm m-0 leading-tight" style={{
          color: '#050505'
        }} data-id="element-290">
            {post.name}
          </p>
          <p className="text-xs m-0 mt-0.5" style={{
          color: '#65676B'
        }} data-id="element-291">
            {post.role}
          </p>
          <div className="flex items-center gap-1 mt-0.5" data-id="element-292">
            <span className="text-xs" style={{
            color: '#65676B'
          }} data-id="element-293">
              {post.timeAgo}
            </span>
            <span style={{
            color: '#65676B'
          }} data-id="element-294">
              ·
            </span>
            <GlobeIcon className="w-3 h-3" style={{
            color: '#65676B'
          }} aria-hidden="true" data-id="element-295" />
          </div>
        </div>
      </div>

      {/* Post body */}
      <div className="px-4 pb-3" data-id="element-296">
        <p className="text-sm leading-relaxed m-0" style={{
        color: '#050505',
        lineHeight: 1.7
      }} data-id="element-297">
          {post.bodyParts}
        </p>
      </div>

      {/* Reactions row */}
      <div className="flex items-center justify-between px-4 py-2" data-id="element-298">
        <div className="flex items-center gap-1.5" data-id="element-299">
          <span className="text-base leading-none" data-id="element-300">{post.reactions}</span>
          <span className="text-xs" style={{
          color: '#65676B'
        }} data-id="element-301">
            A {post.reactionCount} personas les gusta esto
          </span>
        </div>
        <span className="text-xs" style={{
        color: '#65676B'
      }} data-id="element-302">
          {post.commentCount} comentarios · {post.shareCount} compartidos
        </span>
      </div>

      {/* Divider */}
      <div style={{
      borderTop: '1px solid #E4E6EB'
    }} data-id="element-303" />

      {/* Action buttons */}
      <div className="flex items-center px-2 py-1" data-id="element-304">
        <button className="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-lg text-sm font-semibold transition-colors" style={{
        color: '#65676B',
        background: 'transparent',
        border: 'none',
        cursor: 'default'
      }} aria-label="Me gusta" data-id="element-305">
          <ThumbsUpIcon className="w-4 h-4" data-id="element-306" />
          Me gusta
        </button>
        <button className="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-lg text-sm font-semibold transition-colors" style={{
        color: '#65676B',
        background: 'transparent',
        border: 'none',
        cursor: 'default'
      }} aria-label="Comentar" data-id="element-307">
          <MessageCircleIcon className="w-4 h-4" data-id="element-308" />
          Comentar
        </button>
        <button className="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-lg text-sm font-semibold transition-colors" style={{
        color: '#65676B',
        background: 'transparent',
        border: 'none',
        cursor: 'default'
      }} aria-label="Compartir" data-id="element-309">
          <Share2Icon className="w-4 h-4" data-id="element-310" />
          Compartir
        </button>
      </div>

      {/* Divider */}
      <div style={{
      borderTop: '1px solid #E4E6EB'
    }} data-id="element-311" />

      {/* Comments */}
      <div className="px-4 py-3 space-y-3" data-id="element-312">
        {post.comments.map((c, i) => <div key={i} className="flex items-start gap-2" data-id="element-313">
            <div className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold text-white flex-shrink-0 mt-0.5" style={{
          background: c.color
        }} aria-label={`Avatar ${c.name}`} data-id="element-314">
              {c.initial}
            </div>
            <div className="rounded-2xl px-3 py-2 text-sm" style={{
          background: '#F0F2F5',
          color: '#050505'
        }} data-id="element-315">
              <p className="font-bold text-xs m-0 mb-0.5" style={{
            color: '#050505'
          }} data-id="element-316">
                {c.name}
              </p>
              <p className="m-0 text-sm leading-snug" data-id="element-317">{c.text}</p>
            </div>
          </div>)}
      </div>
    </div>;
}
const fbPosts: FbPost[] = [{
  initial: 'M',
  name: 'Mariana L.',
  role: 'Contadora · Mamá de 2 · Buenos Aires',
  timeAgo: 'Hace 2 h',
  avatarColor: 'var(--color-gold)',
  bodyParts: <>
        La primera semana con el Sistema 10x2™ ahorré{' '}
        <strong data-id="element-318">$18.000 en delivery</strong>. Mi familia come mejor y yo no vivo
        más en la cocina. Lo que más me sorprendió fue lo fácil que es:{' '}
        <strong data-id="element-319">2 horas el domingo y tenés 10 días resueltos</strong>. Ya se lo
        recomendé a todas mis amigas.{' '}
        <span style={{
      textDecoration: 'underline',
      color: '#050505'
    }} data-id="element-320">
          comprarlo fue la mejor decisión del año
        </span>
        .
      </>,
  reactions: '👍❤️😮',
  reactionCount: 187,
  commentCount: 23,
  shareCount: 11,
  comments: [{
    initial: 'C',
    name: 'Claudia R.',
    text: '¡Yo también lo compré y es una maravilla! 🙌',
    color: '#6B4FA0'
  }, {
    initial: 'V',
    name: 'Valeria M.',
    text: '¿Dónde lo conseguís? ¡Quiero el link!',
    color: '#2C5F2E'
  }]
}, {
  initial: 'F',
  name: 'Federico R.',
  role: 'Ingeniero · Vive solo · Córdoba',
  timeAgo: 'Hace 5 h',
  avatarColor: 'var(--color-accent)',
  bodyParts: <>
        Soy malísimo cocinando y aún así pude{' '}
        <strong data-id="element-321">resolver 10 días en mi primer intento</strong>. Las
        instrucciones son a prueba de cualquiera. Antes gastaba una fortuna en
        delivery por puro agotamiento. Ahora{' '}
        <strong data-id="element-322">abro el freezer, caliento y listo</strong>. No puedo creer que
        no lo hice antes.{' '}
        <span style={{
      textDecoration: 'underline',
      color: '#050505'
    }} data-id="element-323">
          100% recomendado para los que vivimos solos
        </span>
        .
      </>,
  reactions: '👍❤️🔥',
  reactionCount: 214,
  commentCount: 31,
  shareCount: 18,
  comments: [{
    initial: 'L',
    name: 'Lucas P.',
    text: 'Bro yo igual, ¿funciona para cocinas chicas?',
    color: '#C41E3A'
  }, {
    initial: 'N',
    name: 'Nicolás G.',
    text: '¡Sí! Yo tengo cocina chica y funciona perfecto 👌',
    color: '#B8922A'
  }]
}, {
  initial: 'S',
  name: 'Soledad P.',
  role: 'Administrativa · Mamá soltera · Mendoza',
  timeAgo: 'Hace 1 d',
  avatarColor: '#6B4FA0',
  bodyParts: <>
        Mamá soltera con 2 laburos. Cocinar para 10 días me parecía imposible.{' '}
        <strong data-id="element-324">Hoy mis hijos comen mejor y dejé la culpa atrás</strong>. Ya no
        pido delivery por cansancio. El freezer siempre está lleno y sé
        exactamente qué hay. Esa plata que antes tiraba en delivery{' '}
        <strong data-id="element-325">ahora se queda en mi bolsillo</strong>.{' '}
        <span style={{
      textDecoration: 'underline',
      color: '#050505'
    }} data-id="element-326">
          ojalá lo hubiera encontrado antes
        </span>
        .
      </>,
  reactions: '❤️👍😢',
  reactionCount: 341,
  commentCount: 47,
  shareCount: 29,
  comments: [{
    initial: 'A',
    name: 'Andrea T.',
    text: 'Esto me llegó al alma 💪 ¡Sos una guerrera!',
    color: '#2C5F2E'
  }, {
    initial: 'P',
    name: 'Patricia L.',
    text: '¿Dónde lo consigo? ¡Necesito esto ya!',
    color: '#C41E3A'
  }]
}];
export function SocialProofFooter() {
  return <>
      {/* ── Testimonials ── */}
      <section className="w-full" style={{
      background: 'var(--bg-page)'
    }} aria-label="Testimonios" data-id="element-327">
        <div className="max-w-5xl mx-auto px-4 py-10 md:py-16" data-id="element-328">
          <div className="section-accent" data-id="element-329" />
          <p className="eyebrow text-center mb-3" data-id="element-330">Resultados reales</p>
          <h2 className="text-2xl md:text-3xl text-center mb-8" style={{
          fontFamily: 'var(--font-heading)',
          fontWeight: 600,
          color: 'var(--text-primary)',
          letterSpacing: '-0.02em'
        }} data-id="element-331">
            Lo que dicen quienes ya lo usan
          </h2>

          {/* Facebook-style post cards — single column, centered */}
          <div className="max-w-xl mx-auto space-y-4 mb-10" data-id="element-332">
            <FacebookPostCard post={fbPosts[0]} data-id="element-333" />
            <FacebookPostCard post={fbPosts[1]} data-id="element-334" />
            <FacebookPostCard post={fbPosts[2]} data-id="element-335" />
          </div>

          {/* Final value recap */}
          <div className="rounded-2xl overflow-hidden mb-6" style={{
          border: '1.5px solid rgba(184,146,42,0.3)',
          boxShadow: '0 4px 32px rgba(184,146,42,0.10)'
        }} data-id="element-336">
            {/* Product image above header */}
            <div className="w-full overflow-hidden" data-id="element-337">
              <img src="https://cdn.magicpatterns.com/uploads/avXfojrAUQ7PsUmUipPzNu/20260303_1146_Image_Generation_remix_01kjt2hag0fe6swnp6e4ws1vcz_(1).webp" alt="Sistema 10x2™ — Todo lo que recibís" className="w-full object-cover" style={{
              display: 'block',
              maxHeight: '220px',
              objectPosition: 'center'
            }} data-id="element-338" />
            </div>
            {/* Gold header bar */}
            <div className="px-5 py-3 text-center" style={{
            background: 'linear-gradient(135deg, #C9A84C 0%, #B8922A 100%)'
          }} data-id="element-339">
              <p className="font-bold text-sm m-0 text-white" style={{
              fontFamily: 'var(--font-body)',
              letterSpacing: '0.15em',
              textTransform: 'uppercase'
            }} data-id="element-340">
                Una Vez Más, Esto Es Todo Lo Que Recibís:
              </p>
            </div>

            {/* Value rows */}
            <div className="px-5 py-3" style={{
            background: 'var(--bg-surface)'
          }} data-id="element-341">
              {[{
              label: '✓ Sistema 10x2™ Completo — Método por Bloques',
              price: '$29.999',
              type: 'strike'
            }, {
              label: '✓ Cocina en Piloto Automático + Auditoría de Freezer',
              price: 'Incluido',
              type: 'included'
            }, {
              label: '✓ Acceso desde cualquier dispositivo + Actualizaciones',
              price: 'Incluido',
              type: 'included'
            }, {
              label: '✓ Garantía de Devolución 100% — Sin riesgo',
              price: 'Incluido',
              type: 'included'
            }, {
              label: '🎁 Bono: Manual de Cocina Segura',
              price: '$24.999',
              type: 'strike'
            }, {
              label: '🎁 Bono: Calculadora de Ahorro Real',
              price: '$14.999',
              type: 'strike'
            }, {
              label: '🎁 Bono: Pack de Checklists y Planillas',
              price: '$9.999',
              type: 'strike'
            }, {
              label: '🎁 Bono: Guía de Inicio Rápido',
              price: '$7.999',
              type: 'strike'
            }].map((row, i) => <div key={i} className="value-row" data-id="element-342">
                  <span style={{
                fontWeight: row.type === 'included' ? 400 : 500,
                color: 'var(--text-secondary)'
              }} data-id="element-343">
                    {row.label}
                  </span>
                  {row.type === 'strike' ? <span className="text-sm line-through" style={{
                color: 'var(--text-muted)'
              }} data-id="element-344">
                      {row.price}
                    </span> : <span className="text-xs font-semibold px-2 py-0.5 rounded" style={{
                background: 'var(--color-accent-light)',
                color: 'var(--color-accent)'
              }} data-id="element-345">
                      {row.price}
                    </span>}
                </div>)}
            </div>

            {/* Price block */}
            <div className="px-5 py-7 text-center" style={{
            background: 'var(--bg-surface)',
            borderTop: '1px solid var(--border-light)'
          }} data-id="element-346">
              <p className="eyebrow mb-4" data-id="element-347">Precio de oferta:</p>
              <p className="text-2xl font-bold line-through mb-1" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-muted)'
            }} data-id="element-348">
                $87.995 ARS
              </p>
              <p className="text-5xl font-bold mb-4" style={{
              fontFamily: 'var(--font-heading)',
              color: 'var(--color-primary)',
              lineHeight: 1.1,
              letterSpacing: '-0.02em'
            }} data-id="element-349">
                $19.999 ARS
              </p>
              <p className="text-sm m-0" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-muted)'
            }} data-id="element-350">
                Pago único · Sin suscripciones · Sin cargos ocultos
              </p>
            </div>
          </div>

          {/* CTA — outside the value box */}
          <div className="mb-6" data-id="element-351">
            <a href={CART_URL} onClick={trackAddToCart} className="btn-cta-gold btn-cta-gold-pulse w-full text-base px-6 py-4 rounded-xl mb-2 block text-center" data-id="element-352">
              Quiero Mi Sistema 10x2™ Ahora &gt;&gt;
            </a>
            <p className="text-sm text-center" style={{
            fontFamily: 'var(--font-body)',
            color: 'var(--color-accent)'
          }} data-id="element-353">
              ✓ Descarga inmediata de todo el paquete
            </p>
            <p className="text-xs italic text-center mt-2" style={{
            fontFamily: 'var(--font-body)',
            color: 'var(--text-muted)'
          }} data-id="element-354">
              Pago único. Sin cuotas mensuales ni costos ocultos.{' '}
              <em data-id="element-355">
                Me reservo el derecho de cerrar este descuento en cualquier
                momento después del 10 de marzo de 2026.
              </em>
            </p>
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section className="w-full" style={{
      background: 'var(--bg-surface)'
    }} aria-label="Preguntas frecuentes" data-id="element-356">
        <div className="max-w-2xl mx-auto px-4 py-10 md:py-16" data-id="element-357">
          <div className="section-accent" data-id="element-358" />
          <p className="eyebrow text-center mb-3" data-id="element-359">Preguntas Frecuentes</p>
          <h2 className="text-2xl md:text-3xl text-center mb-8" style={{
          fontFamily: 'var(--font-heading)',
          fontWeight: 600,
          color: 'var(--text-primary)',
          letterSpacing: '-0.02em'
        }} data-id="element-360">
            Todo lo que necesitás saber
          </h2>
          <FAQAccordion data-id="element-361" />
        </div>
      </section>

      {/* ── Footer ── */}
      <footer className="w-full" style={{
      background: 'var(--bg-dark)',
      borderTop: '1px solid rgba(255,255,255,0.06)'
    }} role="contentinfo" data-id="element-362">
        <div className="max-w-2xl mx-auto px-4 py-8" data-id="element-363">
          {/* Brand + description */}

          {/* Legal section */}

          <ul className="space-y-4 mb-8" data-id="element-364">
            {['Términos y Condiciones'].map(link => {})}
          </ul>

          {/* Divider */}
          <div className="mb-6" style={{
          borderTop: '1px solid rgba(255,255,255,0.08)'
        }} data-id="element-365" />

          {/* Legal disclaimer */}

          <p className="text-sm text-center" style={{
          fontFamily: 'var(--font-body)',
          color: 'rgba(255,255,255,0.35)'
        }} data-id="element-366">
            © 2026 · Sistema 10x2™ · Todos los derechos reservados
          </p>
        </div>
      </footer>
    </>;
}